import { FormikField, Input, ListRow, Separator, Slider, Text, VisuallyHidden } from '@betterment/samba-react';
import { iconDisplayForSecurity } from '@betterment/shared-components/src/utils/accountSecurityHelpers';
import { FieldArray, useFormikContext } from 'formik';
import { Fragment } from 'react/jsx-runtime';

import { SecurityGroupAllocation } from './types';

export const SecurityGroupAllocationFields = () => {
  const {
    values: { securityGroupAllocations },
  } = useFormikContext<{ securityGroupAllocations: SecurityGroupAllocation[] }>();

  return (
    <FieldArray name="securityGroupAllocations">
      {arrayHelpers =>
        securityGroupAllocations.map((securityGroupAllocation, index) => {
          const {
            securityGroup: { primarySecurity },
          } = securityGroupAllocation;

          const targetWeightFieldName = `securityGroupAllocations[${index}].targetWeight`;

          return (
            <Fragment key={primarySecurity.id}>
              <Separator />
              <ListRow css={{ paddingX: 0 }}>
                <ListRow.LeadingAsset>
                  {iconDisplayForSecurity({ symbol: primarySecurity.symbol, logo: primarySecurity.logo })}
                </ListRow.LeadingAsset>
                <ListRow.LeadingContent>
                  <Text color="text.selected" variant="text50">
                    {primarySecurity.symbol}
                  </Text>
                  <Text variant="text50">{primarySecurity.name}</Text>
                </ListRow.LeadingContent>
                <ListRow.TrailingContent css={{ marginLeft: 'space.150' }}>
                  <FormikField name={targetWeightFieldName}>
                    <FormikField.Label>
                      <VisuallyHidden>Target weight for {primarySecurity.name}</VisuallyHidden>
                    </FormikField.Label>
                    <FormikField.Control>
                      <Input
                        alignment="right"
                        trailingSymbol="%"
                        type="number"
                        spacing="compact"
                        css={{ width: '6em' }}
                      />
                    </FormikField.Control>
                  </FormikField>
                </ListRow.TrailingContent>
                <ListRow.BottomContent>
                  <Slider
                    min={0}
                    max={100}
                    value={securityGroupAllocation.targetWeight}
                    onValueChange={val => arrayHelpers.form.setFieldValue(targetWeightFieldName, val)}
                  />
                </ListRow.BottomContent>
              </ListRow>
            </Fragment>
          );
        })
      }
    </FieldArray>
  );
};
